import { render, staticRenderFns } from "./CompItemCreateForm.vue?vue&type=template&id=1f77449c"
import script from "./CompItemCreateForm.vue?vue&type=script&lang=js"
export * from "./CompItemCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports